import Layout from '@/page/index/'

export default [
  {
    path: '/',
    component: resolve => require(['@/page/index/index'], resolve),
    name: '主页',
    children: [
      {
        path: '/dot/order/detail/:id',
        component: resolve => require(['@/views/dot/order/order-detail'], resolve),
        name: '订单详情',
        meta: {
          keepAlive: false,
          isTab: true,
          isAuth: false
        }
      },
      {
        path: '/dot/flow/detail-mt/:id',
        component: resolve => require(['@/views/dot/order/taskTemplate/flow-detail-mt'], resolve),
        name: '机翻任务详情',
        meta: {
          keepAlive: false,
          isTab: true,
          isAuth: false
        }
      },
      {
        path: '/dot/flow/detail-marking/:id',
        component: resolve => require(['@/views/dot/order/taskTemplate/flow-detail-marking'], resolve),
        name: '打标任务详情',
        meta: {
          keepAlive: false,
          isTab: true,
          isAuth: false
        }
      },
      {
        path: '/dot/flow/detail-pe/:id',
        component: resolve => require(['@/views/dot/order/taskTemplate/flow-detail-pe'], resolve),
        name: 'PE任务详情',
        meta: {
          keepAlive: false,
          isTab: true,
          isAuth: false,
        }
      },
      {
        path: '/dot/flow/detail-review/:id',
        component: resolve => require(['@/views/dot/order/taskTemplate/flow-detail-pe'], resolve),
        name: '审核任务详情',
        meta: {
          keepAlive: false,
          isTab: true,
          isAuth: false
        }
      },
      {
        path: '/dot/flow/detail-peReview/:id',
        component: resolve => require(['@/views/dot/order/taskTemplate/flow-detail-pe'], resolve),
        name: 'PE&审核任务详情',
        meta: {
          keepAlive: false,
          isTab: true,
          isAuth: false
        }
      },
      {
        path: '/dot/flow/detail-qc/:id',
        component: resolve => require(['@/views/dot/order/taskTemplate/flow-detail-qc'], resolve),
        name: '质控任务详情',
        meta: {
          keepAlive: false,
          isTab: true,
          isAuth: false
        }
      },
      {
        path: '/event/detail-add',
        component: resolve => require(['@/views/events/detail-add'], resolve),
        name: '新增活动(项目)',
        meta: {
          keepAlive: true,
          isTab: true,
          isAuth: false
        }
      },
      {
        path: '/event/detail-view',
        component: resolve => require(['@/views/events/detail-view'], resolve),
        name: '查看活动(项目)',
        meta: {
          keepAlive: true,
          isTab: true,
          isAuth: false
        }
      },
      {
        path: '/event/global-detail-add',
        component: resolve => require(['@/views/events/global-detail-add'], resolve),
        name: '新增活动(全局)',
        meta: {
          keepAlive: true,
          isTab: true,
          isAuth: false
        }
      },
      {
        path: '/event/global-detail-view',
        component: resolve => require(['@/views/events/global-detail-view'], resolve),
        name: '查看活动(全局)',
        meta: {
          keepAlive: true,
          isTab: true,
          isAuth: false
        }
      },
    ]
  }]
